
// Suscripción Tiendas
const STORES = [
  {
    name: "BESIFRAH - Mad Fun Fest UPC",
    id: "0000",
  },
  {
    name: "SIFRAH MAGDALENA",
    id: "0002",
  },
  {
    name: "SIFRAH LARCO",
    id: "0004",
  },
  {
    name: "SIFRAH SCHELL MIRAFLORES",
    id: "0005",
  },
  {
    name: "SIFRAH HIGUERETA",
    id: "0006",
  },
  {
    name: "SIFRAH PIURA",
    id: "0007",
  },
  {
    name: "SIFRAH CHACARILLA",
    id: "0008",
  },
  {
    name: "SIFRAH PLAZA NORTE",
    id: "0009",
  },
  {
    name: "SIFRAH CANADA",
    id: "0010",
  },
  {
    name: "SIFRAH MALL DEL SUR",
    id: "0011",
  },
  {
    name: "SIFRAH PLAZA LIMA SUR",
    id: "0012",
  },
  {
    name: "SIFRAH AREQUIPA CC",
    id: "0013",
  },
  {
    name: "SIFRAH MALL PLAZA BELLAVISTA",
    id: "0014",
  },
  {
    name: "SIFRAH METRO SAN JUAN DE LURIGANCHO",
    id: "0015",
  },
  {
    name: "SIFRAH JR.DE LA UNION",
    id: "0016",
  },
  {
    name: "SIFRAH METRO PLAZA NORTE",
    id: "0017",
  },
  {
    name: "SIFRAH MALL AVENTURA AREQUIPA",
    id: "0018",
  },
  {
    name: "SIFRAH REAL PLAZA PRIMAVERA",
    id: "0019",
  },
  {
    name: "SIFRAH RAMBLA BRASIL",
    id: "0020",
  },
  {
    name: "SIFRAH MALL SANTA ANITA",
    id: "0021",
  },
  {
    name: "SIFRAH REAL PLAZA PURUCHUCO",
    id: "0022",
  },
  {
    name: "SIFRAH METRO GARZON",
    id: "0023",
  },
  {
    name: "SIFRAH METRO BREÑA",
    id: "0024",
  },
  {
    name: "SIFRAH METRO PLAZA LIMA SUR",
    id: "0025",
  },
  {
    name: "SIFRAH PLAZA VEA PIURA",
    id: "0026",
  },
  {
    name: "SIFRAH MALL AVENTURA CHICLAYO",
    id: "0030",
  },
  {
    name: "SIFRAH MALL PLAZA COMAS",
    id: "0031",
  },
  {
    name: "SIFRAH BAJADA BALTA",
    id: "0032",
  },
  {
    name: "SIFRAH LA PLACITA",
    id: "0033",
  },
  {
    name: "SIFRAH ROYAL PLAZA",
    id: "0034",
  },
  {
    name: "SIFRAH MINKA",
    id: "0035",
  },
  {
    name: "SIFRAH AREQUIPA MALL PLAZA",
    id: "0036",
  },
  {
    name: "SIFRAH JOCKEY PLAZA",
    id: "0037",
  },
  {
    name: "SIFRAH OPEN PLAZA ANGAMOS",
    id: "0038",
  },
  {
    name: "SIFRAH OPEN PLAZA LA MARINA",
    id: "0039",
  },
  {
    name: "SIFRAH OPEN PLAZA HUANCAYO",
    id: "0040",
  },
  {
    name: "SIFRAH MAGDALENA 2",
    id: "0041",
  },
  {
    name: "SIFRAH PLAZA SAN MIGUEL",
    id: "0042",
  },
  {
    name: "SIFRAH OPEN PLAZA PIURA",
    id: "0043",
  },
  {
    name: "SIFRAH REAL PLAZA PIURA",
    id: "0044",
  },
  {
    name: "SIFRAH OPEN PLAZA ATOCONGO",
    id: "0045",
  },
  {
    name: "SIFRAH REAL PLAZA PRO",
    id: "0046",
  },
  {
    name: "SIFRAH PLAZA NORTE 2",
    id: "0047",
  },
  {
    name: "SIFRAH MALL PLAZA TRUJILLO",
    id: "0048",
  },
  {
    name: "SIFRAH JESUS MARIA",
    id: "0049",
  },
  {
    name: "SIFRAH REAL PLAZA AREQUIPA",
    id: "0050",
  },
  {
    name: "SIFRAH SANTO DOMINGO AREQUIPA",
    id: "0051",
  },
  {
    name: "SIFRAH REAL PLAZA HUANCAYO",
    id: "0052",
  },
  {
    name: "SIFRAH PLAZA CENTER MOQUEGUA",
    id: "0053",
  },
  {
    name: "SIFRAH PORTAL LA MOLINA",
    id: "0054",
  },
  {
    name: "SIFRAH REAL PLAZA GUARDIA CIVIL",
    id: "0055",
  },
  {
    name: "SIFRAH REAL PLAZA CENTRO CIVICO",
    id: "0056",
  },
  {
    name: "SIFRAH EL SOL CUSCO",
    id: "0057",
  },
  {
    name: "SIFRAH JOCKEY PLAZA 2",
    id: "0058",
  },
  {
    name: "SIFRAH MALL AVENTURA IQUITOS",
    id: "0059",
  },
  {
    name: "SIFRAH REAL PLAZA CUSCO",
    id: "0060",
  },
  {
    name: "SIFRAH PLAZA CENTER TUMBES",
    id: "0061",
  },
  {
    name: "SIFRAH REAL PLAZA PUCALLPA",
    id: "0062",
  },
  {
    name: "SIFRAH REAL PLAZA VILLA MARIA DEL TRIUNFO",
    id: "0063",
  },
  {
    name: "SIFRAH PLAZA CENTER LURIN",
    id: "0064",
  },
  {
    name: "SIFRAH TRUJILLO GAMARRA",
    id: "0065",
  },
  {
    name: "SIFRAH MALL DEL SUR 2",
    id: "0066",
  },
  {
    name: "SIFRAH MALL AVENTURA SJL",
    id: "0067",
  },
  {
    name: "SIFRAH TRUJILLO PIZARRO",
    id: "0068",
  },
  {
    name: "SIFRAH PLAZA VEA SALAVERRY",
    id: "0069",
  },
  {
    name: "SIFRAH PLAZA VEA TRUJILLO",
    id: "0070",
  },
  {
    name: "SIFRAH AREQUIPA MERCADERES",
    id: "0071",
  },
  {
    name: "SIFRAH GAMARRA",
    id: "0072",
  },
  {
    name: "SIFRAH CHIMBOTE LADISLAO ESPINAR",
    id: "0073",
  },
  {
    name: "SIFRAH PLAZA VEA CHINCHA",
    id: "0074",
  },
  {
    name: "SIFRAH PLAZA VEA CHIMBOTE",
    id: "0075",
  },
  {
    name: "SIFRAH PLAZA VEA HIGUERETA",
    id: "0076",
  },
  {
    name: "SIFRAH MEGA PLAZA ICA",
    id: "0077",
  },
  {
    name: "SIFRAH REAL PLAZA HUANUCO",
    id: "0078",
  },
  {
    name: "SIFRAH PLAZA DEL SOL PIURA",
    id: "0079",
  },
  {
    name: "SIFRAH PLAZA DEL SOL HUACHO",
    id: "0080",
  },
  {
    name: "SIFRAH MEGA PLAZA CHINCHA",
    id: "0081",
  },
  {
    name: "SIFRAH ARNALDO MARQUEZ",
    id: "0082",
  },
  {
    name: "SIFRAH OPEN PLAZA CANTA CALLAO",
    id: "0083",
  },
  {
    name: "SIFRAH MEGA PLAZA INDEPENDENCIA",
    id: "0092",
  },
  {
    name: "SIFRAH TOTTUS LOS OLIVOS",
    id: "0093",
  },
  {
    name: "SIFRAH ARENALES",
    id: "0094",
  },
  {
    name: "SIFRAH MALL PLAZA TRUJILLO 2",
    id: "0096",
  },
  {
    name: "SIFRAH HUANCAYO REAL",
    id: "0084",
  },
  {
    name: "SIFRAH BOULEVARD PUNTA HERMOSA",
    id: "0086",
  },
  {
    name: "SIFRAH PARQUE LA MOLINA",
    id: "0098",
  },
  {
    name: "SIFRAH REAL PLAZA JULIACA",
    id: "0097",
  },
];

// Utils functions
function isObjectEmpty(object) {
  var isAllReady = false;
  for (itemKey in object) {
    isAllReady = true;
    if (
      object[itemKey] === "" ||
      object[itemKey] === null ||
      object[itemKey] === undefined
    ) {
      isAllReady = false;
      break;
    }
  }

  return !isAllReady;
}
// END Utils functions

function initSuscripcionTiendas() {
  // id input store: 40727-text-4
  // Add templates autocomplete and fake button
  templateSearchStore = `
    <div class="search-store">
        <input id="autoComplete"  type="search" dir="ltr" spellcheck=false autocorrect="off" autocomplete="off" autocapitalize="off">
    </div>
    `;
  if ($(".search-store").length == 0) {
    $("select#40727-select-2").parent().append(templateSearchStore);
    $("input#40727-text-3").attr("type", "date");
  }

  // Init search store list
  let storeList = STORES.map((el) => el.name);
  if ($("#autoComplete") && $("#autoComplete")[0]) {
    var autoCompleteJS = new window.autoComplete({
      placeHolder: "Buscar una Tienda",
      data: {
        src: storeList,
        cache: true,
      },
      resultItem: {
        highlight: true,
      },
      events: {
        input: {
          selection: (event) => {
            const selection = event.detail.selection.value;
            autoCompleteJS.input.value = selection;
            $("select#40727-select-2").val(selection);
          },
        },
      },
    });
    $("#autoComplete").css({
      width: "30vw",
      borderRadius: "0",
      border: "1px solid #f1f3f5",
      background: "#f1f3f5",
      height: "50px",
      color: "black",
    });
  }

  // Init validates inputs
  $("#40727-select-1").on("change", function () {
    var tipo = this.value;
    if (tipo == "DNI") {
      $("#40727-text-2").attr("maxlength", "8");
      $("#40727-text-2")
        .off("keypress")
        .on("keypress", (ev) => {
          if (!/[0-9]/.test(ev.key)) {
            ev.preventDefault();
          }
        });
    }
    if (tipo == "Carné de extranjería" || tipo == "Pasaporte") {
      $("#40727-text-2").attr("maxlength", "12");
      $("#40727-text-2").off("keypress");
    }
    if (tipo == "RUC") {
      $("#40727-text-2").attr("maxlength", "11");
      $("#40727-text-2")
        .off("keypress")
        .on("keypress", (ev) => {
          if (!/[0-9]/.test(ev.key)) {
            ev.preventDefault();
          }
        });
    }
    if (tipo == "Otros") {
      $("#40727-text-2").removeAttr("maxlength");
      $("#40727-text-2").off("keypress");
    }

    $("#40727-text-2").val("");
  });
  // Nombres, solo texto
  $("#40727-text").on("keypress", function (ev) {
    if (!/^[a-zA-Z\s]$/.test(ev.key)) {
      ev.preventDefault();
    }
  });
  // Apellidos, solo texto
  $("#40727-text-1").on("keypress", function (ev) {
    if (!/^[a-zA-Z\s]$/.test(ev.key)) {
      ev.preventDefault();
    }
  });
  // Fecha no futura y la seleccionada debe dar como resultando mayor a 15 años.
  $("#40727-text-3").on("change", function () {
    const inputDate = new Date($(this).val());
    const today = new Date();

    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 15);

    if (inputDate > today) {
      //alert("La fecha ingresada no puede ser una fecha futura.");
      $(this).val("");
      $(this)
        .parent()
        .parent()
        .find(".messages")
        .html(
          '<p class="help-block error">La fecha ingresada no puede ser una fecha futura</p>'
        );
    } else if (inputDate > minDate) {
      //alert("Debe ser mayor de 15 años.");
      $(this).val("");
      $(this)
        .parent()
        .parent()
        .find(".messages")
        .html('<p class="help-block error">Debe ser mayor de 15 años</p>');
    }
  });

  // Add click event for parallel validation
  $("form.g-container").on("submit", (event) => {
    event.preventDefault();
    let data = {
      firstName: $("#40727-text").val(),
      lastName: $("#40727-text-1").val(),
      email: $("#40727-email").val(),
      phone: $("#40727-phone-1").val(),
      documentType: $("#40727-select-1").val(),
      document: $("#40727-text-2").val(),
      birthdate: $("#40727-text-3").val(),
      //storeName: $("#40727-select-2").val(),
      city: $("#40727-select-4").val(),
      howDidYouFindOut: $("#40727-select-3").val(),
      terms: $("#40727-acceptTerms-1").prop("checked"),
    };

    if (!isObjectEmpty(data) && data.terms) {
      var settingsGet = {
        async: true,
        crossDomain: true,
        url: `https://api.woowup.com/apiv3/multiusers/exist?document=${data.document}&email=${data.email}`,
        type: "GET",
        headers: {
          Authorization:
            "Basic 0245403b79cd44d45f4d32f75bd7bc1525edb7d7050c74154c12fc7a2e12ba62",
          Accept: "application/json",
          "cache-control": "no-cache",
        },
      };

      $.ajax(settingsGet).done(function (response) {

        var jsonData = {
          app: "7INjEMhE1",
          document: data.document,
          email: data.email,
          telephone: data.phone,
          first_name: data.firstName,
          last_name: data.lastName,
          birthdate: data.birthdate.split("/").reverse().join("-"),
          custom_attributes: {
            //tiendaorigen: data.storeName,
            como_te_enteraste: data.howDidYouFindOut,
            ciudad: data.city,
          },
          tags: "actualizacion-datos",
          mailing_enabled: "enabled",
          whatsapp_enabled: "enabled",
          sms_enabled: "enabled"
        };

        if (response.payload.exist) {
          jsonData["service_uid"] = response.payload.userapp_id;
        }
        var settingsPost = {
          async: true,
          crossDomain: true,
          url: "https://events.woowup.com/events/users",
          type: "POST",
          headers: {
            "cache-control": "no-cache",
            Authorization:
              "Basic 0245403b79cd44d45f4d32f75bd7bc1525edb7d7050c74154c12fc7a2e12ba62",
            Accept: "application/json",
          },
          data: jsonData,
        };

        $.ajax(settingsPost).done(function (response) {
        });
      });

      // Send RMS for generate coupon
      //store = STORES.find((store) => store.name === data.storeName);
      if (true) {
        var settingsPostRMS = {
          async: true,
          crossDomain: true,
          url: "https://mbcretail.pe/ws_clienteNew.php",
          type: "POST",
          headers: {
            "cache-control": "no-cache",
            Accept: "application/json",
          },
          data: JSON.stringify({
            nombres: data.firstName,
            apellido: data.lastName,
            correo: data.email,
            telefono: data.phone,
            documento: data.document,
            fechanac: data.birthdate,
            tienda: "0001",
            landing: "form-tiendas",
            promociones: "",
            tipodoc: data.documentType,
          }),
        };

        $.ajax(settingsPostRMS).done(function (response) {
          console.log("CPF RMS coupon generated", JSON.parse(response));

          // Send Email
          var settingsApoloMailing = {
            url: "https://saas.getapolo.com/api/v1/mailing/send-email/",
            type: "POST",
            async: true,
            crossDomain: true,
            headers: {
              Accept: "application/json",
              Authorization: "ApoloToken sk_a00b4a30f20e9e0f",
            },
            data: JSON.stringify({
              email_template_id: "suscripcion-tiendas",
              receptor_email: [data.email],
              context: {
                nombre: data.firstName,
                cupon: JSON.parse(response).cupon,
              },
            }),
          };
          $.ajax(settingsApoloMailing).done(function (responseApolo) {
          });
          // END Send Email
        });
      }

      // Send Apolo create customer
      var settingsApoloCustomer = {
        url: "https://saas.getapolo.com/api/v1/exec/task/sifrah-customer-create@5995cd89-d6ad-4fab-9258-c65469a1bf90",
        type: "POST",
        async: true,
        crossDomain: true,
        headers: {
          Accept: "application/json",
          Authorization: "ApoloToken sk_a00b4a30f20e9e0f",
        },
        data: JSON.stringify({
          first_name: data.firstName,
          last_name: data.lastName,
          email: data.email,
          phone: data.phone,
        }),
      };
      $.ajax(settingsApoloCustomer)
        .done(function (responseApolo) {
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.error("Error en la solicitud:", textStatus, errorThrown);
          console.error("Detalles del error:", jqXHR.responseText);
        });
    }
  });
}
// END Suscripción Tiendas

// Suscripción Web
function initSuscripcionWeb() {
  if ($("input#40750-text-3").prop("type") == "text") {
    $("input#40750-text-3").attr("type", "date");
  }

  // Add click event for parallel validation
  $("form.g-container").on("submit", (event) => {
    event.preventDefault();
    let data = {
      firstName: $("#40750-text").val(),
      lastName: $("#40750-text-1").val(),
      email: $("#40750-email").val(),
      documentType: $("#40750-select-1").val(),
      document: $("#40750-text-2").val(),
      phone: $("#40750-phone-1").val(),
      birthdate: $("#40750-text-3").val(),
      city: $("#40750-select-2").val(),
      terms: $("#40750-acceptTerms-1").prop("checked"),
    };

    if (!isObjectEmpty(data) && data.terms) {
      var settingsGet = {
        async: true,
        crossDomain: true,
        url: `https://api.woowup.com/apiv3/multiusers/exist?document=${data.document}&email=${data.email}`,
        type: "GET",
        headers: {
          Authorization:
            "Basic 0245403b79cd44d45f4d32f75bd7bc1525edb7d7050c74154c12fc7a2e12ba62",
          Accept: "application/json",
          "cache-control": "no-cache",
        },
      };

      $.ajax(settingsGet).done(function (response) {

        var jsonData = {
          app: "7INjEMhE1",
          document: data.document,
          email: data.email,
          first_name: data.firstName,
          last_name: data.lastName,
          telephone: data.phone,
          birthdate: data.birthdate.split("/").reverse().join("-"),
          custom_attributes: {
            ciudad: data.city,
          },
          tags: "suscripcion-web",
          mailing_enabled: "enabled",
          whatsapp_enabled: "enabled",
          sms_enabled: "enabled"
        };

        if (response.payload.exist) {
          jsonData["service_uid"] = response.payload.userapp_id;
        }
        var settingsPost = {
          async: true,
          crossDomain: true,
          url: "https://events.woowup.com/events/users",
          type: "POST",
          headers: {
            "cache-control": "no-cache",
            Authorization:
              "Basic 0245403b79cd44d45f4d32f75bd7bc1525edb7d7050c74154c12fc7a2e12ba62",
            Accept: "application/json",
          },
          data: jsonData,
        };

        $.ajax(settingsPost)
          .done(function (response) {
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            console.error("Error en la solicitud:", textStatus, errorThrown);
            console.error("Detalles del error:", jqXHR.responseText);
          });
      });
    }
  });
}
// END Suscripción Web

// Footer newsletter
function initFooterNewsletter() {
  $('form[data-id="66147"]').submit(function(e){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const phoneRegex = /^[0-9]+$/
    let first_name = $("#66147-text").val()
    let email = $("#66147-email").val()
    let phone = $("#66147-phone").val()
    const headers = { "Authorization": "Basic 0245403b79cd44d45f4d32f75bd7bc1525edb7d7050c74154c12fc7a2e12ba62", "Accept": "application/json", "cache-control": "no-cache", "Content-Type": "application/json"}
  
    if( first_name && emailRegex.test(email) && phoneRegex.test(phone) ) {
      var settingsGet = {
        url: `https://api.woowup.com/apiv3/multiusers/exist?email=${email}`,
        type: "GET", async: true, crossDomain: true, headers: headers,
      };

      $.ajax(settingsGet)
        .done(function (response) {
          var jsonData = {"app": "7INjEMhE1", "tags": "footer-newsletter", "email": email, "first_name": first_name, "telephone": phone,  "mailing_enabled": "enabled", "whatsapp_enabled": "enabled", "sms_enabled": "enabled"}
          var endpoint = "https://events.woowup.com/events/users"
          var method = "POST"
          if (response.payload.exist) {
            jsonData["service_uid"] = response.payload.userapp_id;
          }
          var settings = {
            async: true, crossDomain: true, url: endpoint, type: method,
            headers: {
              "cache-control": "no-cache",
              "Authorization": "Basic 0245403b79cd44d45f4d32f75bd7bc1525edb7d7050c74154c12fc7a2e12ba62",
              "Accept": "application/json",
            }, data: jsonData, }

          $.ajax(settings)
            .done(function (response) {
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
              console.error("Error en la solicitud:", textStatus, errorThrown);
              console.error("Detalles del error:", jqXHR.responseText);
            })
      })
    } else {
    }
  })
}
// END Footer newsletter

// Run the functions
if (
  document.location.pathname == "/pages/suscripcion-tiendas" ||
  document.location.pathname == "/pages/suscripcion-tiendas/"
) {
  var intervalSuscripcionTiendas = setInterval(function () {
    if ($("#40727-text-3").prop("type") === "date") {
      clearInterval(intervalSuscripcionTiendas);
    } else {
      initSuscripcionTiendas();
    }
    $("select#40727-select-2").css("display", "none");
  }, 1000);
}
if (
  document.location.pathname == "/pages/suscripcion-web" ||
  document.location.pathname == "/pages/suscripcion-web/"
) {
  var intervalSuscripcionWeb = setInterval(function () {
    if ($("#40750-text-3").prop("type") === "date") {
      clearInterval(intervalSuscripcionWeb);
    } else {
      initSuscripcionWeb();
    }
  }, 1000);
}
var intervalFooterNewsletter = setInterval(function () {
  if( $('form[data-id="66147"]').length) {
    if ( $('form[data-id="66147"]').hasClass("updated") ) {
      clearInterval(intervalFooterNewsletter);  
    } else {
      initFooterNewsletter()
      $('form[data-id="66147"]').addClass("updated")
    }
  } else {
    clearInterval(intervalFooterNewsletter);
  }
}, 2000);
